Vue.http.headers.common['X-CSRF-TOKEN'] = $('#token').attr('value');
Vue.config.devtools = true;
Vue.config.debug = true;


Vue.mixin({
    methods: {
        notify: function ($type, $title, $text) {
            $.niftyNoty({
                type: $type,
                container: "floating",
                title: $title,
                message: $text,
                closeBtn: true,
                timer: 3000
            });
        },
        cargarEscuelas: function (panel) {
            $(panel).niftyOverlay('show');
            this.$http.get('/api/escuela').then(function (response) {
                this.escuelas = response.data.escuelas;
                this.escuela = response.data.escuela;
                $(panel).niftyOverlay('hide');
            }).catch(function (response) {
                swal('Error', response.data, 'error');
                $(panel).niftyOverlay('hide');
            });
        },
        cargarSemestres: function (panel) {
            $(panel).niftyOverlay('show');
            this.$http.get('/api/semestres').then(function (response) {
                this.semestres = response.data.semestres;
                this.semestre = response.data.semestre_activo;
                $(panel).niftyOverlay('hide');
            }).catch(function (response) {
                swal('Error', response.data, 'error');
                $(panel).niftyOverlay('hide');
            });
        },
        iniciarDataTable: function (tabla, contenedor) {
            $('[data-toggle="tooltip"]').tooltip();
            var dtHandle = $(tabla).DataTable({
                select: {
                    style: 'os',
                    selector: 'td:first-child'
                },
                //  rowId: this.primary_key,
                //  columns: this.headers,
                //   data: this.rows,
                pageLength: 25,
                language: {
                    "sProcessing": "Procesando...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "sZeroRecords": "No se encontraron resultados",
                    "sEmptyTable": "Ningún dato disponible en esta tabla",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix": "",
                    "sSearch": "Buscar:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                },
                buttons: [
                    {
                        extend: 'pdfHtml5',
                        className: 'btn btn-danger btn-labeled fa fa-file-pdf-o',
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    {
                        extend: 'excelHtml5',
                        text: 'Excel',
                        className: 'btn btn-success btn-labeled fa fa-file-excel-o'
                    },
                    {
                        extend: 'print',
                        text: 'Imprimir',
                        className: 'btn btn-primary btn-labeled fa fa-print',
                        customize: function (win) {
                            $(win.document.body)
                                .css('font-size', '8pt !important')
                                .prepend(
                                    '<img src="/images/logo_fras_lg.png" />'
                                );

                            $(win.document.body).find('table')
                                .addClass('compact')
                                .addClass('table-condensed')
                                .css('font-size', '7pt');
                            $(win.document.body).find('tr')
                                .addClass('pad-no')
                        },
                        exportOptions: {
                            columns: ':visible',
                        }
                    },
                    {
                        extend: 'colvis',
                        text: 'Ver/Ocultar columnas',
                        className: 'btn btn-purple btn-labeled fa fa-eye'
                    }
                ]
            });
            dtHandle.buttons()
                .container()
                .appendTo(contenedor);
            console.log(contenedor);
        }
    }
});

Vue.directive('ajax', {
    params: ['complete'],

    bind: function () {
        this.el.addEventListener(
            'submit', this.onSubmit.bind(this)
        );
    },

    onSubmit: function (e) {
        e.preventDefault();
        var correct = this.vm.submit();

        if (correct) {
            var requestType = this.getRequestType();
            this.vm
                .$http[requestType](this.el.action, this.vm.$data)
                .then(this.onComplete.bind(this))
                .catch(this.onError.bind(this));
        }
    },

    onComplete: function () {
        if (this.params.complete) {
            swal('Completado', this.params.complete, 'success');
        }
        this.vm.reset();
    },

    onError: function (response) {

        for (var firsterror in response.data) break;

        $.niftyNoty({
            type: "danger",
            container: "floating",
            title: "Error!",
            message: response.data[firsterror],
            closeBtn: true,
            timer: 4000
        });
        this.vm.error();
    },

    getRequestType: function () {
        var method = this.el.querySelector('input[name="_method"]');
        return (method ? method.value : this.el.method).toLowerCase();
    }
});


Vue.directive('select', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function () {
        var self = this;
        $(this.el)
            .select2()
            .on('change', function () {
                self.set(this.value)
            })
    },
    update: function (value) {
        $(this.el).val(value).trigger('change')
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    }
});

Vue.directive('selectmultiple', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function () {
        var self = this;
        $(this.el)
            .select2({
                data: this.params.options
            })
            .on('change', function () {
                self.set($(self.el).val()); // Don't use this.value
            })
    },
    update: function (value) {
        $(this.el).val(value).trigger('change')
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    }
});

Vue.directive('selectjson', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function () {
        var self = this;
        $(this.el)
            .select2()
            .on('change', function () {
                if (this.value != "") {
                    self.set(JSON.parse(this.value));
                }
            });
    },
    update: function (value) {
        $(this.el).val(value).trigger('change')
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    }
});

$(document).ready(function(){
    $(".labelauty").labelauty();
});